import { LABELS } from "../../../../../config/constants";
import Select, { Option } from "../../../../base/Select/Select";
import { ChangeEvent } from "react";

interface BedsOptionProps {
  value?: number;
  onChange: (value: number) => void;
  className?: string;
}

const OPTIONS = [
  { label: LABELS.NO_MIN, value: 0 },
  { label: "1+", value: 1 },
  { label: "2+", value: 2 },
  { label: "3+", value: 3 },
  { label: "4+", value: 4 },
  { label: "5+", value: 5 },
  { label: "6+", value: 6 },
] satisfies Option[];

export default function BedsOption({ value, onChange, className }: BedsOptionProps) {
  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const newValue = Number(e.target.value);
    onChange(newValue);
  };

  return (
    <Select
      label="Bedrooms"
      value={value}
      onChange={handleChange}
      className={className}
      options={OPTIONS}
    />
  );
}
